import React, { useState } from 'react';
import './CodeBlock.css';

interface CodeBlockProps {
  language: string;
  code: string;
}

/**
 * Code block component
 * Displays code with copy functionality (no syntax highlighting)
 */
function CodeBlock({ language, code }: CodeBlockProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy code:', err);
    }
  };

  return (
    <div className="code-block">
      <div className="code-header">
        <span className="code-language">{language || 'code'}</span>
        <button
          className="btn-copy"
          onClick={handleCopy}
          aria-label="Copy code"
          type="button"
        >
          {copied ? (
            <span className="copy-success">✓ Copied</span>
          ) : (
            <span>Copy</span>
          )}
        </button>
      </div>
      <pre className="code-content">
        <code>{code}</code>
      </pre>
    </div>
  );
}

export default CodeBlock;
